import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import proxy from "../../proxy";

const initialState = {
    checklist: [],
    completedList: [],
};

export const fetchChecklist = createAsyncThunk("fetchChecklist", async (data) => {
    const { projectId, token } = data;
    const response = await fetch(`${proxy}/api/${projectId}`, {
        method: "GET",
        headers: {
            "Content-Type": "application/json",
            "Authorization": `Bearer ${token}`
        }
    })

    const status = response.status;

    const responseBody = await response.json();

    return { status, responseBody };
});

export const addChecklist = createAsyncThunk("addChecklist", async (data) => {
    const { token } = data;
    const response = await fetch(`${proxy}/api/checklist/add`, {
        method: "POST",
        headers: {
            "Content-Type": "application/json",
            "Authorization": `Bearer ${token}`
        },
        body: JSON.stringify(data)
    });

    const status = response.status;
    const responseBody = await response.json();

    return { status, responseBody };
});


export const deleteChecklistTodo = createAsyncThunk(
    "deleteChecklistTodo",
    async (data) => {
        const { projectId, todoId, token } = data;

        const response = await fetch(`${proxy}/api/checklist/delete-todo`, {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Authorization": `Bearer ${token}`
            },
            body: JSON.stringify({
                projectId,
                todoId
            })
        });

        const status = response.status;
        const responseBody = await response.json();

        return { status, responseBody };
    }
);


export const fetchCompletedList = createAsyncThunk("fetchCompletedList", async (data) => {
    const { projectId, token } = data;
    const response = await fetch(`${proxy}/api/checklist/completed?projectId=${projectId}`, {
        method: "GET",
        headers: {
            "Content-Type": "application/json",
            "Authorization": `Bearer ${token}`
        }
    })

    const status = response.status;

    const responseBody = await response.json();

    return { status, responseBody };
});



export const checklistSlice = createSlice({

    name: "checklist",
    initialState,
    extraReducers: (builder) => {
        builder.addCase(fetchChecklist.fulfilled, (state, action) => {
            state.checklist = action?.payload?.responseBody?.data?.todos;
        })

        builder.addCase(addChecklist.fulfilled, (state, action) => {
            console.log("status:", action.payload)
            if (action.payload.status === 200) {
                state.checklist = action?.payload?.responseBody?.data?.todos;
            }
        })

        builder.addCase(deleteChecklistTodo.fulfilled, (state, action) => {
            if (action.payload.status === 200) {
                state.checklist = action?.payload?.responseBody?.data?.todos;
            }
        });

        builder.addCase(fetchCompletedList.fulfilled, (state, action) => {
            state.completedList = action?.payload?.responseBody?.data;
        })
    }

});

export default checklistSlice.reducer;